import { makeStyles } from '@surveycake/rc';

const facebook = '#3b5998';
const iconSize = 14;

export const useStyles = makeStyles([
  [
    'facebook',
    `
		width: 100%;
		background-color: ${facebook};

		&:hover:not(:disabled) {
			background-color: ${facebook};
		}

		&:disabled {
			background-color: ${facebook};
			opacity: 0.6;
		}
	`
  ],
  [
    'facebookIcon',
    `
		width: ${iconSize}px;
		height: ${iconSize}px;
		margin-right: 5px;
	`
  ]
]);
